import script from "./DCStreaksCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./DCStreaksCreate.vue?vue&type=script&setup=true&lang=ts"

import "./DCStreaksCreate.vue?vue&type=style&index=0&id=4e82c35c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e82c35c"]])

export default __exports__